import { CloseOutlined } from '@ant-design/icons';
import React from 'react';
import "./ItemButton.css";
var ItemButton = function ItemButton(_ref) {
  var id = _ref.id,
    name = _ref.name,
    onDelete = _ref.onDelete;
  return /*#__PURE__*/React.createElement("div", {
    className: "button",
    key: id
  }, name, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(CloseOutlined, {
    style: {
      color: '#E8E8E8'
    },
    onClick: function onClick() {
      onDelete(id);
    }
  })));
};
export default ItemButton;